import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import { HOME_CONFIG_MENU_LABLE } from 'constants/wizardConstants';

export const StatusButton = ({ label, idx, setStep, length, iconName, screen }) => {
  return (
    <div
      className="list"
      onClick={() => {
        setStep(idx);
      }}
    >
      <div className="wrapper">
        {length > 0 && <i className="headerCheckbox" />}
        <div className="tit">
          <div className={`img ic_final_${iconName}`} />
          <h1 className="main-text">{label}</h1>
        </div>

        <p className="sub-text">
          {!screen
            ? length > 0
              ? `${length}${i18n.t('BTY_W_T_REGISTER')}`
              : i18n.t('BTY_W_T_UNREGISTER')
            : i18n.t(HOME_CONFIG_MENU_LABLE[screen])}
        </p>
      </div>
    </div>
  );
};
StatusButton.propTypes = {
  label: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  length: PropTypes.number.isRequired,
  iconName: PropTypes.string.isRequired,
  screen: PropTypes.string,
};
StatusButton.defaultProps = { screen: null };
export default StatusButton;
